import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.views.FranchiseeProjectView.';
  public static readonly projectContainerEmpty = `${Id.prefix}projectContainerEmpty`;
  public static readonly unableToChangeProjectState = `${Id.prefix}unableToChangeProjectState`;
  public static readonly quoteOutstanding = `${Id.prefix}quoteOutstanding`;
  public static readonly cannotCancelProjectWithAcceptedQuotes = `${Id.prefix}cannotCancelProjectWithAcceptedQuotes`;
  public static readonly purchaseOrderNotCompleted = `${Id.prefix}purchaseOrderNotCompleted`;
  public static readonly quoteNotCompleted = `${Id.prefix}quoteNotCompleted`;
}

export class LangFranchiseeProjectView {
  private constructor() {}
  public static projectContainerEmpty(): string {
    return interpolate(Id.projectContainerEmpty);
  }
  public static unableToChangeProjectState(params: { stateText: string }): string {
    return interpolate(Id.unableToChangeProjectState, params);
  }
  public static quoteOutstanding(params: { quoteTitle: string; quoteState: string }): string {
    return interpolate(Id.quoteOutstanding, params);
  }
  public static cannotCancelProjectWithAcceptedQuotes(): string {
    return interpolate(Id.cannotCancelProjectWithAcceptedQuotes);
  }
  public static purchaseOrderNotCompleted(params: { purchaseOrderTitle: string; purchaseOrderState: string }): string {
    return interpolate(Id.purchaseOrderNotCompleted, params);
  }
  public static quoteNotCompleted(params: { quoteTitle: string; quoteState: string }): string {
    return interpolate(Id.quoteNotCompleted, params);
  }
}

export class FranchiseeProjectViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.projectContainerEmpty,
      "{{glossary 'project'}} container is empty",
      'Error message when project container is empty'
    );
    register.add(
      Id.unableToChangeProjectState,
      "Unable to {{stateText}} {{glossary 'project'}} as one or more items have not been completed.",
      'Error message when unable to change project state'
    );
    register.add(
      Id.quoteOutstanding,
      "{{glossary 'quote'}} '{{quoteTitle}}' is still outstanding (Currently {{quoteState}}).",
      'Error message when a quote is still outstanding'
    );
    register.add(
      Id.cannotCancelProjectWithAcceptedQuotes,
      "Cannot cancel a {{glossary 'project'}} with accepted {{glossary 'quote:plural'}}",
      'Error message when trying to cancel a project with accepted quotes'
    );
    register.add(
      Id.purchaseOrderNotCompleted,
      "{{glossary 'purchase-order'}} '{{purchaseOrderTitle}}' has not been completed (Currently {{purchaseOrderState}}).",
      'Error message when a purchase order has not been completed'
    );
    register.add(
      Id.quoteNotCompleted,
      "{{glossary 'quote'}} '{{quoteTitle}}' has not been completed (Currently {{quoteState}}).",
      'Error message when a quote has not been completed'
    );
  }
}
